module.exports = __webpack_public_path__ + "static/media/review_book.6b0b24e9.png";